
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $9881d956eae96fc9$exports = {};

$parcel$export($9881d956eae96fc9$exports, "flex", function () { return $9881d956eae96fc9$export$97691fbb80847c19; }, function (v) { return $9881d956eae96fc9$export$97691fbb80847c19 = v; });
$parcel$export($9881d956eae96fc9$exports, "flex-container", function () { return $9881d956eae96fc9$export$69d7a39fa31a000b; }, function (v) { return $9881d956eae96fc9$export$69d7a39fa31a000b = v; });
$parcel$export($9881d956eae96fc9$exports, "flex-gap", function () { return $9881d956eae96fc9$export$31a9da8b58047a44; }, function (v) { return $9881d956eae96fc9$export$31a9da8b58047a44 = v; });
var $9881d956eae96fc9$export$97691fbb80847c19;
var $9881d956eae96fc9$export$69d7a39fa31a000b;
var $9881d956eae96fc9$export$31a9da8b58047a44;
$9881d956eae96fc9$export$97691fbb80847c19 = `vi3c6W_flex`;
$9881d956eae96fc9$export$69d7a39fa31a000b = `vi3c6W_flex-container`;
$9881d956eae96fc9$export$31a9da8b58047a44 = `vi3c6W_flex-gap`;


export {$9881d956eae96fc9$exports as default};
//# sourceMappingURL=flex-gap_css.mjs.map
